module.exports = __webpack_public_path__ + "img/hotelBg3.e7cc17c2.png";